// extracted by mini-css-extract-plugin
var _1 = "p7L5S";
var _2 = "M3T7L";
var _3 = "jtXyq";
export { _1 as "base", _2 as "theme-dark", _3 as "theme-light" }
